import { createUseStyles } from "react-jss";
import {colors} from "../../../constants/colors";
import {breakpoints} from "../../../constants/breakpoints";

const styles = createUseStyles({
  mainFormDiv: {
    "& .row": {
      [`@media (max-width: ${breakpoints.xl}px)`]: {
        display:"grid",
      }
    },
    "& .col-md-4": {
      [`@media (max-width: ${breakpoints.xl}px)`]: {
        marginBottom: "32px"
      }
    },
  },
  details:{
    display:"flex",
    flexDirection:"row",
    justifyContent:"space-between",
    margin: "32px 0 0"
  },
  title:{
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "28px",
    color: colors.lightBlack,
  },
  description:{
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.mediumGrey,
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      marginBottom:"25px",
    }
  },
  personalDetails:{
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    color: colors.grey,
  },
  formContainer:{
    width:"512px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width:"300px",
    }
  },
  containerMargin:{
    marginBottom:"20px"
  },
  inputContainer:{
    display:"flex",
    flexDirection:"column",
    marginBottom: "16px",
    "& input":{
      height: "44px",
      width: "100%",
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      padding: "10px 14px",
      "&:focus": {
        outline: "none"
      }
    },
    "& input[disabled]":{
      color: colors.inactiveGrey,
      backgroundColor: colors.brightBlue,
      '-webkit-text-fill-color': colors.inactiveGrey,
      opacity: 1,
    },
  },
  inputContainerMembership:{
    marginBottom:"16px",
    display:"flex",
    flexDirection:"column",
    "& div": {
      "& svg": {
        margin: "auto 0px"
      },
      display: "flex",
      backgroundColor: colors.brightBlue,
      border: "1px solid " + colors.darkGrey,
      borderRadius: "8px",
      height: "44px",
      // padding: "10px 14px",
    },
    "& input":{
      border: "none",  
      marginLeft: "10px",
      padding: "0px",
      "&:focus": {
        outline: "none"
      }
    },
    "& input[disabled]":{
      color: colors.inactiveGrey,
      backgroundColor: colors.brightBlue,
      '-webkit-text-fill-color': colors.inactiveGrey,
      opacity: 1,
    },
  },
  label:{
    fontSize: "14px",
    fontWeight:"500",
    lineHeight:"20px",
    color: colors.grey,
    marginBottom:"6px"
  },
  error: {
    color: colors.red,
    fontSize: "14px",
    textAlign: "left",
    "& p": {
      margin: 0,
    }
  },
  note: {
    fontSize: "14px",
    color: colors.mediumGrey,
    marginBottom: "16px",
  },
  dividerContainer: {
    display: "flex",
    alignItems: "center",
  },
  rowBtns: {
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      display:"flex !important",
    }
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin:"20px 0px"
  },
  littleBorder: {
    margin:"16px 0px"
  },
  buttonContainer:{
    display: "flex",
    justifyContent:"flex-end",
    marginBottom:"30px"
  },
  btnContainer:{
    display:"flex",
    flexDirection:"row",
    alignItems:"center"
  },
  button:{
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    marginRight:"12px",
  },
  colBtn: {
    display: "flex"
  },
  leaveButton: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    display:"flex",
    alignItems:"center",
    marginBottom: "28px",
    "& span": {
      display: "flex"
    }
  },
  helpIcon: {
    width: "16px",
    height: "16px",
    marginLeft: "5px",
    cursor: "pointer",
    padding: "unset",
    "&:hover": {
      "& path": {
        stroke: colors.inactiveGrey
      }
    },
  },
  concurTooltip: {
    paddingBottom: "14px",
    inset: "auto auto -14px 0px !important",
    "& .tooltip-inner": {
      maxWidth: "320px !important",
      padding: "12px",
      fontSize: "12px",
      fontWeight:500,
      textAlign:"start",
      borderRadius: "8px",
    },
    "& .tooltip-arrow": {
      display: "none"
    },
    "& a":{
      textDecoration:"none",
      color: colors.darkBlue
    }
  },
  tripLink: {
    width: "16px",
    height: "16px",
    backgroundSize: "12px"
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center"
  },
  inputMailContainer: {
    marginBottom: "16px",
    display: "flex",
    flexDirection: "column",
    "& input":{
      border: "none",
      marginLeft: "10px",
      padding: "0px",
      "&:focus": {
        outline: "none"
      }
    },
    "& input[disabled]":{
      width: "-webkit-fill-available",
      color: colors.inactiveGrey,
      backgroundColor: colors.brightBlue,
      borderRadius: "8px",
      '-webkit-text-fill-color': colors.inactiveGrey,
      opacity: 1,
    },
  },
  editButton: {
    padding:"8px 12px",
    width: "44px",
    height: "42px",
    borderLeft: "1px solid " + colors.darkGrey,
    borderRadius:"0px 8px 8px 0px",
    backgroundColor: colors.white,
    display: "flex",
    alignItems:"flex-start",
    "& span":{
      marginLeft: "0px",
    },
    "& svg": {
      width:"20px",
      height:"20px",
    },
    "&[class*='disabled']": {
      backgroundColor: `${colors.brightBlue} !important`,
      borderRight: `none !important`,
      borderTop:  `none !important`,
      borderBottom: `none !important`,
      borderLeft: `"1px solid " + ${colors.darkGrey} !important`,
      pointerEvents: "none",
      "& svg": {
        "& path":{
          stroke: colors.inactiveGrey
        }
      },
    },
    "&:disabled": {
      backgroundColor: colors.brightBlue,
    }
  },
  editDiv: {
    justifyContent: "space-between",
    display: "flex",
    backgroundColor: colors.brightBlue,
    border: "1px solid " + colors.darkGrey,
    height: "44px",
    borderLeft: "1px solid " + colors.darkGrey,
    borderRadius:"8px",
  },
  emailTooltip: {
    "& .tooltip-inner": {
      maxWidth: "217px !important",
      fontSize: "12px",
      padding: "12px",
      textAlign:"center",
      borderRadius: "8px",
    },
    "& .tooltip-arrow": {
      display: "none"
    }
  },
});

export default styles;
